import LegalPage from './LegalPage';
import { terms } from './legal';

export default function TermsOfService() {
  return <LegalPage doc={terms} />;
}
